import React from "react";
import { dateByformat } from "../../../utils/dateHelper";
import { Button, Tag } from "antd";
import { currencyFormat, statusLabel } from "../../../utils/media";
import { Link } from "react-router-dom";
import { formatString } from "../../../utils/formatString";

function getDaysBetween(start, end) {
  const startDate: any = new Date(start);
  const endDate: any = new Date(end);
  const msInDay: any = 1000 * 60 * 60 * 24;
  return Math.ceil((endDate - startDate) / msInDay);
}

export const bookingCol = [
  { id: 1, headerName: "Status", field: "leaseStatus", checked: true, hide: false },
  { id: 2, headerName: "Booking ID", field: "bookingId", checked: true, hide: false },
  { id: 3, headerName: "Property", field: "propertyDetails.propertyName", checked: true, hide: false },
  { id: 4, headerName: "Unit Code", field: "propertyDetails.unitCode", checked: true, hide: false },
  { id: 5, headerName: "Tenant", field: "tenantDetails.tenantNameEN", checked: true, hide: false },
  { id: 6, headerName: "Annual Rent", field: "bookingTerms.annualBaseRent", checked: true, hide: false },
  { id: 7, headerName: "Start Date", field: "leaseTerms.leaseStartDate", checked: true, hide: false },
  { id: 8, headerName: "End Date", field: "leaseTerms.leaseEndDate", checked: true, hide: false },
  { id: 9, headerName: "Contract Type", field: "leaseType", checked: true, hide: false },
  { id: 10, headerName: "Payments", field: "bookingTerms.numberOfInstallments", checked: true, hide: false },
  { id: 11, headerName: "AWB No", field: "shipmentNumber", checked: true, hide: false },
  { id: 12, headerName: "Owner Name", field: "ownerName", checked: true, hide: false },
  { id: 13, headerName: "Property Admin", field: "propertyAdmin", checked: true, hide: false },
  { id: 14, headerName: "Unit Approved Rent", field: "unitApprovedRent", checked: true, hide: false },
  { id: 15, headerName: "Actions", field: "action", checked: true, hide: false },

  // 🔹 Extra fields from leaseCol not present before
  { id: 16, headerName: "Nationality", field: "tenantDetails.nationality", checked: false, hide: true },
  { id: 17, headerName: "Email", field: "tenantDetails.email", checked: false, hide: true },
  { id: 18, headerName: "Marital Status", field: "tenantDetails.maritalStatus", checked: false, hide: true },
  { id: 19, headerName: "Signatory Name", field: "signatoryName", checked: false, hide: true },
  { id: 20, headerName: "Signatory Designation", field: "signatoryDesignation", checked: false, hide: true },
  { id: 21, headerName: "Lease Nature", field: "leaseTerms.leaseNature", checked: false, hide: true },
  { id: 22, headerName: "Lease Executive", field: "leaseManager.name", checked: false, hide: true },
  { id: 23, headerName: "External Agent", field: "externalAgent", checked: false, hide: true },
  { id: 24, headerName: "Vacating Date", field: "vacatingDate", checked: false, hide: true },
  { id: 25, headerName: "Occupants", field: "tenantDetails.numberOfOcupants", checked: false, hide: true },
  { id: 26, headerName: "Rent Free Days", field: "leaseTerms.rentFreeDays", checked: false, hide: true },
  { id: 27, headerName: "Rent Free Start", field: "leaseTerms.rentFreeStartDate", checked: false, hide: true },
  { id: 28, headerName: "Rent Free End", field: "leaseTerms.rentFreeEndDate", checked: false, hide: true },
  { id: 29, headerName: "Move-in Date", field: "leaseTerms.moveInDate", checked: false, hide: true },
  { id: 30, headerName: "Ejari Contract No", field: "ejari.contractNumber", checked: false, hide: true },
  { id: 31, headerName: "Bedrooms", field: "propertyDetails.unitSubType", checked: false, hide: true },
  { id: 32, headerName: "Usage Type", field: "propertyDetails.usagesType", checked: false, hide: true },
  { id: 33, headerName: "Built-up Area", field: "propertyDetails.areaSqft", checked: false, hide: true },
  { id: 34, headerName: "Contract Rent", field: "contractRent", checked: false, hide: true },
  { id: 35, headerName: "Unit Type", field: "unitType", checked: false, hide: true },
  { id: 36, headerName: "Business Unit", field: "businessUnit", checked: false, hide: true },
  { id: 37, headerName: "Is AutoPay Active", field: "isAutoPayActive", checked: false, hide: true },
  { id: 38, headerName: "DEWA", field: "propertyDetails.dewa", checked: false, hide: true },
  { id: 39, headerName: "Address Line 1", field: "propertyDetails.address.addressLine1", checked: false, hide: true },
  { id: 40, headerName: "Address Line 2", field: "propertyDetails.address.addressLine2", checked: false, hide: true },
  { id: 41, headerName: "Community", field: "propertyDetails.address.community", checked: false, hide: true },
  { id: 42, headerName: "Sub Community", field: "propertyDetails.address.subCommunity", checked: false, hide: true },
  { id: 43, headerName: "Security Deposit", field: "leaseTerms.securityDeposit", checked: false, hide: true },
  { id: 47, headerName: "Community", field: "propertyDetails.address.community", checked: false, hide: true },
  { id: 48, headerName: "Sub Community", field: "propertyDetails.address.subCommunity", checked: false, hide: true },
  { id: 49, headerName: "Security Deposit", field: "leaseTerms.securityDeposit", checked: false, hide: true },
  { id: 50, headerName: "Mobile", field: "tenantDetails.mobileNumber", checked: false, hide: true },
  {
    id: 51,
    headerName: "Direct Debit Enabled",
    field: "propertyDetails?.isDirectDebitEnable",
    checked: false,
    hide: true,
  },
  { id: 52, headerName: "Approved Rate", field: "approvedRate", checked: false, hide: true },
  { id: 53, headerName: "No. Of Installments", field: "bookingTerms.numberOfInstallments", checked: false, hide: true },
  { id: 154, headerName: "ID", field: "recordNumber", checked: false, hide: true },
];

export const bookingColumn = (bookingColumns, MoreAction) => {
  return bookingColumns.map((col) => {
    if (col.field === "leaseStatus") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => (
          <Tag className="tag-sm" color="warning">
            {statusLabel(data?.leaseStatus, data?.leaseStatusHistory)}
          </Tag>
        ),
        minWidth: 220,
      };
    } else if (col.field === "bookingTerms.annualBaseRent") {
      return {
        ...col,
        cellRendererFramework: ({ data }) =>
          data?.bookingTerms?.annualBaseRent ? (
            <div style={{ position: "absolute", left: "20px" }}>
              {currencyFormat(data.bookingTerms?.renewalAmount || data.bookingTerms?.annualBaseRent)}
            </div>
          ) : (
            ""
          ),
        minWidth: 350,
      };
    } else if (col.field === "leaseTerms.leaseStartDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) =>
          data?.leaseTerms?.leaseStartDate && dateByformat(data?.leaseTerms?.leaseStartDate, "DD-MM-YYYY"),
        minWidth: 150,
      };
    } else if (col.field === "leaseTerms.leaseEndDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) =>
          data?.leaseTerms?.leaseEndDate && dateByformat(data?.leaseTerms?.leaseEndDate, "DD-MM-YYYY"),
        minWidth: 150,
      };
    } else if (col.field === "leaseType") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => statusLabel(data?.leaseType),
      };
    } else if (col.field === "contractRent") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => (
          <div style={{ position: "absolute", left: "20px" }}>{currencyFormat(data?.leaseTerms?.contractAmount)}</div>
        ),
        minWidth: 350,
      };
    } else if (col.field === "leaseTerms.moveInDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => dateByformat(data?.leaseTerms?.moveInDate, "DD-MM-YYYY"),
        minWidth: 150,
      };
    } else if (col.field === "leaseTerms.rentFreeStartDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => dateByformat(data?.leaseTerms?.rentFreeStartDate, "DD-MM-YYYY"),
        minWidth: 150,
      };
    } else if (col.field === "leaseTerms.rentFreeEndDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => dateByformat(data?.leaseTerms?.rentFreeEndDate, "DD-MM-YYYY"),
        minWidth: 150,
      };
    } else if (col.field === "leaseTerms.rentFreeDays") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => {
          if (data?.leaseTerms?.rentFreeStartDate && data?.leaseTerms?.rentFreeEndDate) {
            return getDaysBetween(data?.leaseTerms?.rentFreeStartDate, data?.leaseTerms?.rentFreeEndDate);
          }
          return "0";
        },
      };
    } else if (col.field === "vacatingDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => dateByformat(data?.vacatingDate, "DD-MM-YYYY"),
        minWidth: 150,
      };
    } else if (col.field === "action") {
      return {
        ...col,
        maxWidth: 200,
        pinned: "right",
        cellRendererFramework: (row) => MoreAction(row),
      };
    } else if (col.field === "propertyDetails?.isDirectDebitEnable") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => <span>{data?.propertyDetails?.isDirectDebitEnable ? "Yes" : "No"}</span>,
      };
    }
    return col;
  });
};
